import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from '../Markdown/Markdown'

const MessageCard = ({title, content, className = '', children, style}) => {

  return (
    <div className={`message-card ${className}`} style={style}>
      <h2>{title}</h2>
      {
        content &&
        <ReactMarkdown source={content} className="markdown" />
      }
      {children}
    </div>
  )
}

MessageCard.propTypes = {
  title: PropTypes.node,
  content: PropTypes.string,
  children: PropTypes.node
}

export default MessageCard



// WEBPACK FOOTER //
// ./src/components/Shell/MessageCard.js